import { type ApolloError, gql, useQuery } from '@apollo/react-hooks';

type CaptchaData = {
  questionId: string;
  imageData: string;
  submission: string;
};

export type UseCaptcha = {
  data: CaptchaData | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: () => void;
};

export const useCaptcha = (): UseCaptcha => {
  const {
    data: captchaData,
    loading,
    error,
    refetch,
  } = useQuery(
    gql`
      query {
        getCaptcha
      }
    `,
    {
      fetchPolicy: 'no-cache',
      skip: !navigator.onLine, // Skip the query if there is no network connection
    },
  );

  // if skip: true, loading would be false, data would be undefined
  const data = captchaData?.getCaptcha;
  return { data, loading, error, refetch };
};
